
import { defineComponent, ref, onBeforeMount } from 'vue';
import { taskData, registerLearner, getExistedLearner } from '@/utils/select_task_service';
import axios, { AxiosError } from 'axios';
import ErrorMessage from '@/components/global/ErrorMessage.vue';
import Greetings from '@/components/global/Greetings.vue';
// eslint-disable-next-line
import router from '@/router';

export default defineComponent({
  name: 'LearnerSelectTask',
  // props: ['query'],
  props: {
    query: {
      type: Object,
      default: () => ({}),
    },
  },
  components: { ErrorMessage, Greetings },
  setup(props) {
    const skillName = ref(localStorage.getItem('skillName'));
    const profName = ref(localStorage.getItem('proficiency'));
    const skillId = ref(props.query.skill_id);
    const profId = ref(props.query.proficiency_id);
    const programId = ref(props.query.program_id);
    const helpmateLink = ref(localStorage.getItem('helpmateLink'));
    const email = ref(localStorage.getItem('email'));
    const fullname = ref(localStorage.getItem('userName'));
    // const initialData: any = ref(localStorage.getItem('allInitialData'));
    const rows = ref();
    const taskName = ref();
    const taskDesc = ref();
    const additional = ref([]);
    const emailValidationMsg = ref();
    const buttonDisable = ref(true);
    const learnerTaskId = ref();
    const renderReady = ref();
    const errorResponse = ref();
    const showErrorMessage = ref(false);
    const programName = ref();
    const taskAssignmentStrategy = ref();
    const reviewerAssignmentStrategy = ref();
    const checkOne = () => {
      additional.value = [];
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const setTaskDesc = (taskname: any, description: any, event: any) => {
      const cb = event.target.checked;

      if (cb === true) {
        buttonDisable.value = false;
        taskName.value = taskname;
        taskDesc.value = description;
      } else {
        buttonDisable.value = true;
        taskName.value = null;
        taskDesc.value = null;
      }
    };
    const emailValidate = async (emailID: string) => {
      // const emailRegexp = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;
      // const emailRegexp = /^\w+([\.-]?\w+)*@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
      const emailRegexp = /^\w+([.-]?\w+)*@[a-zA-Z0-9-]+\.[a-zA-Z0-9-]+$/;
      const isEmailValid = emailRegexp.test(emailID);
      // console.log(`validate_res ${isEmailValid}`);
      return isEmailValid;
      // Log.info(`Validate Response, ${validate_res}`);
    };
    const createLearner = async () => {
      try {
        if (!email.value) {
          emailValidationMsg.value = 'Please enter an email address';
          setTimeout(() => {
            emailValidationMsg.value = null;
          }, 6000);
        } else {
          const validateEmail = await emailValidate(email.value);
          if (!validateEmail) {
            emailValidationMsg.value = 'Enter Valid Email';
            setTimeout(() => {
              emailValidationMsg.value = null;
            }, 6000);
            return;
          }
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          const learnerData: any = {
            email: email.value,
            linked_task_id: additional.value[0],
            skill_id: props.query.skill_id,
            proficiency_id: props.query.proficiency_id,
            program_id: props.query.program_id,
          };
          if (learnerTaskId.value) {
            Object.assign(learnerData, { learner_task_id: learnerTaskId.value });
          }
          if (fullname.value) {
            Object.assign(learnerData, { fullname: fullname.value });
          }
          renderReady.value = false;
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          const res: any = await registerLearner('/v1/createLearnerActivities', learnerData);
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          const createRes: any = res.data;
          if (createRes.emailValidation === false) {
            emailValidationMsg.value = 'Enter Valid Email';
            setTimeout(() => {
              emailValidationMsg.value = null;
            }, 6000);
          } else {
            console.log(createRes.message);
            router.push({ name: 'SolidifyLearnerSubmitTask', query: { learner_task_id: createRes.learnerTaskId, program_id: learnerData.program_id } });
          }
        }
      } catch (error) {
        renderReady.value = true;
        if (axios.isAxiosError(error)) {
          const err = error as AxiosError;
          // console.log(err.response?.data);
          errorResponse.value = (err.response?.data as { message: string })?.message;
          // console.log(`errorMessage.value ${errorMessage.value}`);
        } else {
          errorResponse.value = 'There is some issue in registering task for learner, please contact helpmate.';
        }
        showErrorMessage.value = true;
        // console.log(`Error in creating ${error}`);
      }
    };

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const getTaskData = async (data: any) => {
      try {
        renderReady.value = false;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const res: any = await taskData('/task/search', data);
        // console.log(`res for task search ${JSON.stringify(res)}`);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const taskresponse: any[] = res.data.tasks;
        renderReady.value = true;
        if (taskresponse.length === 0) {
          errorResponse.value = 'There is no task available for this skill and proficiency, please contact helpmate.';
          showErrorMessage.value = true;
        } else {
          taskresponse.sort((a, b) => a.task_type.localeCompare(b.task_type)); //added tasks sorting, Desktop will come on top
          rows.value = taskresponse;
        }
      } catch (error) {
        renderReady.value = true;
        if (axios.isAxiosError(error)) {
          const err = error as AxiosError;
          // console.log(err.response?.data);
          errorResponse.value = (err.response?.data as { message: string })?.message;
          // console.log(`errorMessage.value ${errorMessage.value}`);
        } else {
          errorResponse.value = 'There is an issue to fetch task record, please contact helpmate.';
        }
        showErrorMessage.value = true;
      }
    };
    onBeforeMount(async () => {
      try {
        programName.value = localStorage.getItem('programName');
        reviewerAssignmentStrategy.value = localStorage.getItem('reviewerAssignmentStrategy');
        taskAssignmentStrategy.value = localStorage.getItem('taskAssignmentStrategy');
        // router.go(0);
        const data = {
          skill: props.query.skill_id,
          proficiency: props.query.proficiency_id,
          program_id: props.query.program_id,
        };
        renderReady.value = false;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const res: any = await getExistedLearner('/learner/journey/stat', data);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const existingRecord: any = res.data;
        renderReady.value = true;
        if (existingRecord.is_learner_not_allowed) {
          // console.log('inside learner not allowed');
          router.push({ path: '/solidify', query: { skill_id: skillId.value, proficiency_id: profId.value, program_id: programId.value } });
          return;
        }
        if (existingRecord.learnerData) {
          if (existingRecord.learnerData.technical_hold) {
            // console.log('learner on hold select task');
            router.push({ path: '/solidify', query: { skill_id: skillId.value, proficiency_id: profId.value, program_id: programId.value } });
          }
          learnerTaskId.value = existingRecord.learnerData.learner_task_id;
          if (existingRecord.learnerData.learner_status === 'Need Reviewer and Need Reviewee' || existingRecord.learnerData.learner_status === 'Need Reviewee') {
            router.push({ path: '/solidify/peerReview', query: { learner_task_id: existingRecord.learnerData.learner_task_id } });
          } else if (existingRecord.learnerData.learner_status === 'Need Reviewer' || existingRecord.learnerData.learner_status === 'Passed') router.push({ path: '/solidify/done', query: { learner_task_id: learnerTaskId.value } });
          else if (props.query.program_id !== 'infinity' && existingRecord.learnerData.learner_status === 'Registered') {
            router.push({ path: '/solidify/submitTask', query: { learner_task_id: existingRecord.learnerData.learner_task_id, program_id: props.query.program_id } });
          }
        }
        await getTaskData(data);
      } catch (error) {
        renderReady.value = true;
        if (axios.isAxiosError(error)) {
          const err = error as AxiosError;
          // console.log(err.response?.data);
          errorResponse.value = (err.response?.data as { message: string })?.message;
          // console.log(`errorMessage.value ${errorMessage.value}`);
        } else {
          errorResponse.value = 'There is an issue in fetching Data, please contact helpmate.';
        }
        showErrorMessage.value = true;
      }
    });

    return {
      rows,
      // columns,
      skillName,
      profName,
      skillId,
      profId,
      programId,
      taskName,
      taskDesc,
      additional,
      email,
      emailValidationMsg,
      buttonDisable,
      setTaskDesc,
      checkOne,
      createLearner,
      helpmateLink,
      learnerTaskId,
      renderReady,
      fullname,
      errorResponse,
      showErrorMessage,
      programName,
      taskAssignmentStrategy,
      reviewerAssignmentStrategy,
      // cohortPanel,
      // solidifyPanel,
    };
  },
});
